
import { ATTESTATION_PARENT, ATTESTATION_SELF } from './v3';
import { HIPAA_V4 } from './v4';
import type { SignerRelationship } from '../../types/family';

/** The active version string — v4 for all flows. */
export const ACTIVE_HIPAA_VERSION = HIPAA_V4.version; // 'v4.0-2026-04'

/** The active self-signing template. */
export const ACTIVE_HIPAA = HIPAA_V4;

/** @deprecated Use getAttestationText() instead */
export { ATTESTATION_TEXT } from './v3';

/**
 * Get the correct attestation text for the signer relationship.
 * - parent: "I am the legal parent/guardian of the minor patient…"
 * - self/spouse: "I am the patient named above…"
 */
export function getAttestationText(relationship: SignerRelationship): string {
  switch (relationship) {
    case 'parent':
      return ATTESTATION_PARENT;
    case 'spouse':
    case 'self':
    default:
      return ATTESTATION_SELF;
  }
}

/**
 * Get the appropriate HIPAA template body for the signer relationship.
 * - self/parent/spouse: all use v4 templates (removes named individual)
 */
export function getHipaaBody(relationship: SignerRelationship): string {
  switch (relationship) {
    case 'parent':
      return HIPAA_V4.childBody;
    case 'spouse':
      return HIPAA_V4.spouseBody;
    case 'self':
    default:
      return HIPAA_V4.selfBody;
  }
}
